module.exports = __webpack_public_path__ + "static/media/laptopwithmobile.377dd5c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/laptopwithmobile.png
// module id = 90
// module chunks = 0